import { useEffect } from 'react';
import { ppData } from '../configs/ppData.config';
import { useImage } from '../hooks/useImage';
import { useActiveOrFirstVariant } from '../hooks/useActiveOrFirstVariant';
const { originalTitle, id, sku, url, type, vendor, artistCollection, mainCollection, hierarchyPath, isOldCustom } = ppData;
export const DLProduct = () => {
    const image = useImage();
    const variant = useActiveOrFirstVariant();
    useEffect(() => {
        if (variant === undefined)
            return;
        window.dataLayer.push({
            product: {
                title: originalTitle,
                id,
                sku,
                type,
                vendor,
                image,
                image_300: `${image}&width=300`,
                link: url,
                ...artistCollection !== undefined && { artist_name: artistCollection.title },
                collection_name: mainCollection?.title ?? '',
                collection_path: mainCollection?.url ?? '',
                collection_names: hierarchyPath?.map(({ name }) => name) ?? [],
                hierarchy: hierarchyPath ?? [],
                price: variant.price / 100,
                price_compare_max: variant.compareAtPrice / 100,
                currency: 'USD',
                variant_title: variant.optionNames.join(' / ')
            },
            page_context: {
                items: [{
                        category_name: isOldCustom ? 'Custom' : mainCollection?.title ?? '',
                        category_path: isOldCustom ? 'custom' : hierarchyPath?.map(({ name }) => name)?.join(' > ') ?? mainCollection?.title ?? '',
                        ...isOldCustom
                            ? { category_path_lv0: 'Custom' }
                            : hierarchyPath?.reduce((obj, { name }, i) => {
                                return { ...obj, [`category_path_lv${i}`]: name };
                            }, {}),
                        category_type: isOldCustom ? 'custom' : 'subject',
                        product_id: id,
                        product_title: originalTitle,
                        sku,
                        type
                    }]
            }
        });
    }, [variant]);
    return null;
};
